import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Collapse,
  FormControlLabel,
  IconButton,
  Paper,
  Switch,
  Typography,
} from "@mui/material";
import { Card, CardBody, Col, Form, Row } from "reactstrap";
import CustomDrawer from "../../../components/CustomDrawer";
import ShowTileDialogStack from "./ShowTileDialogStack";
import PathologyMapEffects from "../pathology/PathologyMapEffects";

export default function ShowTileMapAndDialogs({
  // Map + drawer
  slideId,
  lang,
  info,
  fetchSlide,
  drawerOpen,
  toggleDrawer,
  showStudentPinToggle,
  studentPinsPanelOpen,
  setStudentPinsPanelOpen,
  studentsSeePublicPins,
  onStudentsPublicPinsChange,
  pathologyEnabled,
  // Dialog stack
  dialogStackProps,
}) {
  return (
    <>
      <Row>
        <Col md="12">
          <Card className="card-user">
            <CardBody>
              <Form>
                <Box sx={{ position: "relative", width: "100%" }}>
                  <div id="map" style={{ width: "100%", height: "70vh" }} />
                  {showStudentPinToggle ? (
                    <Paper
                      elevation={4}
                      style={{ marginLeft: "45px", }}
                      sx={{
                        position: "absolute",
                        top: 12,
                        left: 12,
                        zIndex: 5000,
                        maxWidth: 300,
                        borderRadius: 1,
                        overflow: "hidden",
                        boxShadow: 3,
                      }}
                    >
                      <Box
                        onClick={() => setStudentPinsPanelOpen((o) => !o)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          px: 1,
                          py: 0.5,
                          bgcolor: "action.hover",
                        }}
                      >
                        <Typography variant="caption" sx={{ flex: 1, fontWeight: 600 }}>
                          Student view (pins)
                        </Typography>
                        <IconButton size="small" aria-label="Expand">
                          {studentPinsPanelOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                      </Box>
                      <Collapse in={studentPinsPanelOpen}>
                        <Box sx={{ px: 1.5, pb: 1.5, pt: 0.5 }}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={studentsSeePublicPins}
                                onChange={onStudentsPublicPinsChange}
                                size="small"
                              />
                            }
                            sx={{ alignItems: "flex-start", m: 0 }}
                            label={
                              <Typography variant="caption" color="text.secondary" component="span">
                                Show official library pins to students linked to you. When off, they only
                                see pins you add on public slides.
                              </Typography>
                            }
                          />
                        </Box>
                      </Collapse>
                    </Paper>
                  ) : null}
                  {pathologyEnabled ? <PathologyMapEffects /> : null}
                </Box>
                <CustomDrawer
                  data={info}
                  lang={lang}
                  slide_id={slideId}
                  fetchSlide={fetchSlide}
                  open={drawerOpen}
                  toggleDrawer={toggleDrawer}
                />
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <ShowTileDialogStack {...dialogStackProps} />
    </>
  );
}
